import React from 'react';
import ReactTable from 'react-table';
import { Box } from '@mui/material';

const DisputesChildTable = React.memo(({
  catalogs, showMultipleSessions
}) => {
  const columns = [
    {
      Header: 'Item',
      minWidth: 150,
      id: 'lot',
      sortable: false,
      resizable: false,
      className: 'cell-font-size',
      Cell: ({ original }) => (
        <span>
          <span>
            {showMultipleSessions
              ? `Session ${original.catalogPrefix} `
              : null}
          </span>
          <a href={original?.lotUrl} target="_blank" rel="noopener noreferrer">
            {`${original.lotNumber || ''} ${original?.title}`}
          </a>
        </span>
      )
    },
    {
      Header: 'Hammer',
      accessor: 'hammer',
      id: 'hammer',
      sortable: false,
      minWidth: 65,
      className: 'cell-font-size',
      Cell: ({ original }) => (
        <Box>
          {`${original.currencySymbol || ''}${original.hammer}`}
        </Box>
      )
    },
    {
      Header: 'BP',
      accessor: 'buyPrem',
      id: 'buyPrem',
      sortable: false,
      minWidth: 65,
      className: 'cell-font-size',
      Cell: ({ original }) => (
        <Box>
          {`${original.currencySymbol || ''}${original.buyPrem}`}
        </Box>
      )
    },
    {
      Header: 'Live Fee',
      accessor: 'liveFee',
      id: 'liveFee',
      sortable: false,
      minWidth: 65,
      className: 'cell-font-size',
      Cell: ({ original }) => (
        <Box>
          {`${original.currencySymbol || ''}${original.liveFee}`}
        </Box>
      )
    },
    {
      Header: 'Payable',
      accessor: 'payble',
      id: 'result-payable',
      sortable: false,
      minWidth: 65,
      className: 'cell-font-size',
      Cell: ({ original }) => (
        <Box>
          {`${original.currencySymbol || ''}${original.payble}`}
        </Box>
      )
    }
  ];

  return (
    <Box p={4}>
      <ReactTable
        minRows={0}
        pageSize={catalogs.items.length}
        data={catalogs.items}
        columns={columns}
        showPagination={false}
        style={{ width: '100%' }}
        className="-highlight"
      />
    </Box>
  );
});

export default DisputesChildTable;
